export const SELECTED_USER = 'selectedUser';
export const USER_LIST = 'userList';

export const HAS_EXTERNAL = 'hasExternal';

export const ENTITIES = 'entities';
export const ACCESS_TO_DASHBOARD = 'accessToDashboard';
export const DASHBOARD_VIEWS = 'dashboardViews';
export const ACCESS_TO_CONTACT_LIST = 'accessToContactList';
export const CUSTOM_COLUMNS = 'customsColumns';
export const TAGS = 'tags';
export const ACCESS_TO_GROUP_RISK_ASSESMENT = 'accessToGroupRiskAssessment';
export const PROJECT_OWNER_ACCESS = 'projectOwnerAccess';
export const ENTITY_ADMIN_ACCESS = 'entityAdminAccess';
export const PROJECT_OWNER = 'projectOwner';
export const ENTITY_ADMIN = 'entityAdmin';
export const USER = 'user';
